import { render, staticRenderFns } from "./Poster.vue?vue&type=template&id=241bbfc4&scoped=true&"
import script from "./Poster.vue?vue&type=script&lang=js&"
export * from "./Poster.vue?vue&type=script&lang=js&"
import style0 from "./Poster.vue?vue&type=style&index=0&id=241bbfc4&lang=scss&scoped=true&"
import style1 from "./Poster.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241bbfc4",
  null
  
)

export default component.exports